/**
 * Real Auth Service Client
 * Uses Connect-RPC to communicate with the backend.
 * 
 * This client routes all RPC calls through the Connect transport,
 * which includes auth, logging, and refresh interceptors.
 * DO NOT bypass this by using raw fetch() for auth endpoints.
 */

import { createClient } from '@connectrpc/connect';
import { transport } from '@/services/api/client';
import { UserService } from '@puppycad/proto';

// Sprint 01 (C4): Create Connect RPC client with interceptors
// Sprint 02 (C2): Used for refreshTokens RPC call
export const authClient = createClient(UserService, transport);

